import { render, staticRenderFns } from "./PorCompetencia.vue?vue&type=template&id=54c2754a"
import script from "./PorCompetencia.vue?vue&type=script&lang=js"
export * from "./PorCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports